// Samo eksportuje konfiguraciju
const firebaseConfig = {
  apiKey: "AIzaSyBHFrMFKjmIDvJzuOo8-oYK2ScBSws8WRM",
  authDomain: "amdlog-74b9f.firebaseapp.com",
  projectId: "amdlog-74b9f",
  storageBucket: "amdlog-74b9f.appspot.com",
  messagingSenderId: "957498179698",
  appId: "1:957498179698:web:f1b6a72b0746f0064c02eb",
  measurementId: "G-TSRX8WES21"
};



export default firebaseConfig;
